import { useTranslation } from '@eti/providers';
import { price as priceUtil } from '@eti/utils';
import { Icon } from '@eti/components';
import { seatCharacteristics } from '../../../utils/constants';
import { getSeatIconId } from '../../../utils/seat';
import { SeatWrapper, TextContent, IconWrapper } from './StyledComponents';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SeatCharacteristic = _ref => {
  let {
    isOpen = false,
    characteristic,
    priceFrom,
    isUnavailable
  } = _ref;
  const {
    t
  } = useTranslation();
  const priceFromLabel = t('Product.SeatMap.Characteristic.PriceFrom.Text');
  const standardLabel = t('Product.SeatMap.Characteristic.Standard.Label');
  const standardDescription = t('Product.SeatMap.Characteristic.Standard.Description');
  const frontRowLabel = t('Product.SeatMap.Characteristic.FrontRow.Label');
  const frontRowDescription = t('Product.SeatMap.Characteristic.FrontRow.Description');
  const legroomLabel = t('Product.SeatMap.Characteristic.ExtraLegroom.Label');
  const legroomDescription = t('Product.SeatMap.Characteristic.ExtraLegroom.Description');
  const economyComfortLabel = t('Product.SeatMap.Characteristic.EconomyComfort.Label');
  const economyComfortDescription = t('Product.SeatMap.Characteristic.EconomyComfort.Description');
  const unavailableLabel = t('Product.SeatMap.Characteristic.Unavailable.Label');
  const unavailableDescription = t('Product.SeatMap.Characteristic.Unavailable.Description');
  const getCharacteristicLabel = () => {
    if (isUnavailable) {
      return unavailableLabel;
    }
    switch (characteristic) {
      case seatCharacteristics.LEG_SPACE:
        return legroomLabel;
      case seatCharacteristics.FRONT_OF_CABIN:
        return frontRowLabel;
      case seatCharacteristics.ECONOMY_COMFORT:
        return economyComfortLabel;
      case seatCharacteristics.NORMAL:
      default:
        return standardLabel;
    }
  };
  const getCharacteristicDescription = () => {
    if (isUnavailable) {
      return unavailableDescription;
    }
    switch (characteristic) {
      case seatCharacteristics.LEG_SPACE:
        return legroomDescription;
      case seatCharacteristics.FRONT_OF_CABIN:
        return frontRowDescription;
      case seatCharacteristics.ECONOMY_COMFORT:
        return economyComfortDescription;
      case seatCharacteristics.NORMAL:
      default:
        return standardDescription;
    }
  };
  return /*#__PURE__*/_jsxs(SeatWrapper, {
    isOpen: isOpen,
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      isOpen: isOpen,
      size: isOpen ? '1.5' : '1',
      children: /*#__PURE__*/_jsx(Icon, {
        id: isUnavailable ? 'c_flat-seat-unavailable' : getSeatIconId(characteristic),
        size: "16px"
      })
    }), /*#__PURE__*/_jsxs(TextContent, {
      isOpen: isOpen,
      children: [/*#__PURE__*/_jsx("h3", {
        children: getCharacteristicLabel()
      }), !isUnavailable && /*#__PURE__*/_jsxs("span", {
        children: [priceFromLabel, ": ", priceUtil.formatPrice(priceFrom)]
      }), isOpen && /*#__PURE__*/_jsx("p", {
        children: getCharacteristicDescription()
      })]
    })]
  });
};
export default SeatCharacteristic;